var _rect, _path, _path2, _path3, _g, _g2, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResume(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4500,
    height: 4500,
    viewBox: "0 0 4500 4500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 4500,
    height: 4500,
    fill: "#A0A8BE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M483.4 1564V584H909C970.6 584 1024.27 594.733 1070 616.2C1115.73 637.667 1151.2 668 1176.4 707.2C1201.6 746.4 1214.2 792.6 1214.2 845.8V862.6C1214.2 921.4 1200.2 969 1172.2 1005.4C1144.2 1041.8 1109.67 1068.4 1068.6 1085.2V1110.4C1105.93 1112.27 1134.87 1125.33 1155.4 1149.6C1175.93 1172.93 1186.2 1204.2 1186.2 1243.4V1564H1001.4V1270C1001.4 1247.6 995.333 1229.4 983.2 1215.4C972 1201.4 952.867 1194.4 925.8 1194.4H668.2V1564H483.4ZM668.2 1026.4H889.4C933.267 1026.4 967.333 1014.73 991.6 991.4C1016.8 967.133 1029.4 935.4 1029.4 896.2V882.2C1029.4 843 1017.27 811.733 993 788.4C968.733 764.133 934.2 752 889.4 752H668.2V1026.4ZM1367.97 1564V584H1997.97V752H1552.77V985.8H1958.77V1153.8H1552.77V1396H2006.37V1564H1367.97Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M823.6 2738.6C748 2738.6 681.267 2725.07 623.4 2698C565.533 2670.93 520.267 2632.2 487.6 2581.8C454.933 2531.4 438.6 2470.73 438.6 2399.8V2360.6H620.6V2399.8C620.6 2458.6 638.8 2502.93 675.2 2532.8C711.6 2561.73 761.067 2576.2 823.6 2576.2C887.067 2576.2 934.2 2563.6 965 2538.4C996.733 2513.2 1012.6 2481 1012.6 2441.8C1012.6 2414.73 1004.67 2392.8 988.8 2376C973.867 2359.2 951.467 2345.67 921.6 2335.4C892.667 2324.2 857.2 2313.93 815.2 2304.6L783 2297.6C715.8 2282.67 657.933 2264 609.4 2241.6C561.8 2218.27 524.933 2187.93 498.8 2150.6C473.6 2113.27 461 2064.73 461 2005C461 1945.27 475 1894.4 503 1852.4C531.933 1809.47 572.067 1776.8 623.4 1754.4C675.667 1731.07 736.8 1719.4 806.8 1719.4C876.8 1719.4 938.867 1731.53 993 1755.8C1048.07 1779.13 1091 1814.6 1121.8 1862.2C1153.53 1908.87 1169.4 1967.67 1169.4 2038.6V2080.6H987.4V2038.6C987.4 2001.27 979.933 1971.4 965 1949C951 1925.67 930.467 1908.87 903.4 1898.6C876.333 1887.4 844.133 1881.8 806.8 1881.8C750.8 1881.8 709.267 1892.53 682.2 1914C656.067 1934.53 643 1963 643 1999.4C643 2023.67 649.067 2044.2 661.2 2061C674.267 2077.8 693.4 2091.8 718.6 2103C743.8 2114.2 776 2124 815.2 2132.4L847.4 2139.4C917.4 2154.33 978.067 2173.47 1029.4 2196.8C1081.67 2220.13 1122.27 2250.93 1151.2 2289.2C1180.13 2327.47 1194.6 2376.47 1194.6 2436.2C1194.6 2495.93 1179.2 2548.67 1148.4 2594.4C1118.53 2639.2 1075.6 2674.67 1019.6 2700.8C964.533 2726 899.2 2738.6 823.6 2738.6ZM1710.42 2738.6C1630.16 2738.6 1561.09 2724.13 1503.22 2695.2C1446.29 2665.33 1402.42 2623.33 1371.62 2569.2C1341.76 2514.13 1326.82 2449.27 1326.82 2374.6V1739H1511.62V2380.2C1511.62 2439.93 1528.42 2487.07 1562.02 2521.6C1596.56 2556.13 1646.02 2573.4 1710.42 2573.4C1774.82 2573.4 1823.82 2556.13 1857.42 2521.6C1891.96 2487.07 1909.22 2439.93 1909.22 2380.2V1739H2094.02V2374.6C2094.02 2449.27 2078.62 2514.13 2047.82 2569.2C2017.96 2623.33 1974.09 2665.33 1916.22 2695.2C1859.29 2724.13 1790.69 2738.6 1710.42 2738.6Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M463.4 3844V2864H806.4L975.8 3718H1001L1170.4 2864H1513.4V3844H1334.2V2999.8H1309L1141 3844H835.8L667.8 2999.8H642.6V3844H463.4ZM1697.97 3844V2864H2327.97V3032H1882.77V3265.8H2288.77V3433.8H1882.77V3676H2336.37V3844H1697.97Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2205_51)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 3474,
    cy: 3325,
    rx: 591,
    ry: 606,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2205_51)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 3474,
    cy: 3325,
    rx: 591,
    ry: 606,
    fill: "white"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3449.25 3708.75C3462.92 3722.42 3485.08 3722.42 3498.75 3708.75L3721.49 3486.01C3735.16 3472.34 3735.16 3450.18 3721.49 3436.51C3707.82 3422.84 3685.66 3422.84 3671.99 3436.51L3474 3634.5L3276.01 3436.51C3262.34 3422.84 3240.18 3422.84 3226.51 3436.51C3212.84 3450.18 3212.84 3472.34 3226.51 3486.01L3449.25 3708.75ZM3439 2965L3439 3684L3509 3684L3509 2965L3439 2965Z",
    fill: "#A0A8BE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2205_51",
    x: 2879,
    y: 2719,
    width: 1190,
    height: 1220,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2205_51"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2205_51",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2205_51",
    x: 2879,
    y: 2719,
    width: 1190,
    height: 1220,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2205_51"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2205_51",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResume);
export default __webpack_public_path__ + "static/media/resume.a14fa7b642b725c62091bcb774294606.svg";
export { ForwardRef as ReactComponent };